var _linearGradient, _path, _linearGradient2, _path2, _path3, _path4, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GroupMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p5s0ZWgAt~fs9whzuyKRXa",
    x1: 18.989,
    x2: 38.479,
    y1: 512.15,
    y2: 482.979,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5059c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4750b3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p5s0ZWgAt~fs9whzuyKRXa)",
    d: "M8.857,20.619L38,9.036v21.297c0,0.895-0.725,1.619-1.619,1.619H8.857V20.619z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p5s0ZWgAt~fs9whzuyKRXb",
    x1: 2.697,
    x2: 30.999,
    y1: 506.672,
    y2: 489.042,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5961c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a41ac"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p5s0ZWgAt~fs9whzuyKRXb)",
    d: "M4,9v21.381C4,31.275,4.725,32,5.619,32h30.762c0.397,0,0.757-0.149,1.039-0.387L4,9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b83eb",
    d: "M5.619,6.048h30.762C37.275,6.048,38,6.772,38,7.667v1.37L22.823,19.377 c-1.1,0.75-2.547,0.75-3.646,0L4,9.036v-1.37C4,6.772,4.725,6.048,5.619,6.048z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38,15H11.619C10.172,15,9,16.172,9,17.619V32h1l28-16V15z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38,15.548H11.619c-1.169,0-2.119,0.95-2.119,2.119V32H11l27-16V15.548z",
    opacity: 0.07
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p5s0ZWgAt~fs9whzuyKRXc",
    x1: 24.989,
    x2: 44.479,
    y1: 502.15,
    y2: 472.979,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28afea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b88da"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p5s0ZWgAt~fs9whzuyKRXc)",
    d: "M14.857,30.619L44,19.036v21.297c0,0.895-0.725,1.619-1.619,1.619H14.857V30.619z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p5s0ZWgAt~fs9whzuyKRXd",
    x1: 8.711,
    x2: 36.982,
    y1: 496.668,
    y2: 479.058,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28afea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b88da"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p5s0ZWgAt~fs9whzuyKRXd)",
    d: "M10,19.036v21.297c0,0.895,0.725,1.619,1.619,1.619h30.762c0.397,0,0.757-0.149,1.039-0.387 L10,19.036z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10,18.476h34v1.395L29.979,30.961c-1.753,1.386-4.205,1.386-5.958,0 L10,19.871V18.476z",
    opacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10,18.071h34v1.386L29.401,30.199c-1.426,1.068-3.376,1.068-4.802,0 L10,19.458V18.071z",
    opacity: 0.07
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M11.619,16.048h30.762c0.895,0,1.619,0.725,1.619,1.619v1.37L28.823,29.377 c-1.1,0.75-2.547,0.75-3.646,0L10,19.036v-1.37C10,16.772,10.725,16.048,11.619,16.048z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GroupMessage);
export default __webpack_public_path__ + "static/media/icons8-group-message.a30e0bb07acee54a5186b5edebd7d599.svg";
export { ForwardRef as ReactComponent };